/**
    * @description      : 
    * @author           : Saif
    * @group            : 
    * @created          : 04/11/2024 - 22:59:59
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/11/2024
    * - Author          : Saif
    * - Modification    : 
**/
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faEye, faCheck, faTimes, faFilter, faEdit, faHeart, faTrash } from "@fortawesome/free-solid-svg-icons";

import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import CustomTable from "../../Components/CustomTable";
import CustomModal from "../../Components/CustomModal";

import CustomPagination from "../../Components/CustomPagination"
import CustomInput from "../../Components/CustomInput";
import CustomButton from "../../Components/CustomButton";


import "./style.css";
import { useGet, usePost, useDelete } from "../../Api";
import { male1 } from "../../Assets/images";
import FormatDateTime from "../../Components/DateFormate";
import { base_url } from "../../Api/apiConfig";
import { useNotification } from '../../Components/GlobalNotification';

export const Favourite = () => {
  const { showNotification } = useNotification();

  const [favoritesData, setFavoritesData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [inputValue, setInputValue] = useState('');
  const [paginationData, setPaginationData] = useState({
    total: 0,
    lastPage: 1,
    perPage: 10,
    currentPage: 1
  });
  const { ApiData: UseeListingData, loading: UseeListingLoading, error: UseeListingError, get: GetUseeListing } = useGet(`/all-favorites?page=${currentPage}`);
  const [isRemoving, setIsRemoving] = useState(false);


  const navigate = useNavigate();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRemoveFavorite = async (listingId) => {
    setIsRemoving(true);
    try {
      const token = localStorage.getItem('login');
      const response = await fetch(`${base_url}/add-favorite/${listingId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      const result = await response.json();
      
      if (result?.message?.includes('removed from favorites')) {
        showNotification({ type: 'success', title: 'Success', message: 'Removed from favorites' });
        GetUseeListing(); // Refresh the list
      } else {
        showNotification({ type: 'success', title: 'Success', message: 'Favorite updated successfully' });
        GetUseeListing(); // Refresh the list
      }
    } catch (error) {
      showNotification({ type: 'error', title: 'Error', message: 'Failed to remove from favorites' });
    } finally {
      setIsRemoving(false);
    }
  };

  useEffect(() => {
    GetUseeListing();
  }, [currentPage]);




  const inActive = () => {
    setShowModal(false)
    setShowModal2(true)
  }
  const ActiveMale = () => {
    setShowModal3(false)
    setShowModal4(true)
  }

  const handleChange = (e) => {
    setInputValue(e.target.value);
  }

  const filterData = favoritesData?.filter(item =>
    item?.list_id?.toString().toLowerCase().includes(inputValue.toLowerCase()) ||
    item?.listing?.title?.toLowerCase().includes(inputValue.toLowerCase())
  );




  useEffect(() => {
    document.title = 'Kvr Listing Management';
    GetUseeListing()

  }, []);


  useEffect(() => {
    if (UseeListingData) {
      // Debug: Log the API response to see the structure
      console.log('Favorites API Response:', UseeListingData);
      
      // The API response structure: { data: [...], current_page, last_page, total, etc. }
      setFavoritesData(UseeListingData?.data || []);
      setPaginationData({
        total: UseeListingData?.total || 0,
        lastPage: UseeListingData?.last_page || 1,
        perPage: UseeListingData?.per_page || 10,
        currentPage: UseeListingData?.current_page || 1
      });
    }
  }, [UseeListingData]);

  const upcomingHeader = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "listing_title",
      title: "Listing Title",
    },
    {
      key: "type",
      title: "Type",
    },
    {
      key: "bathrooms",
      title: "Bathrooms",
    },
    {
      key: "size",
      title: "Size",
    },
    {
      key: "status",
      title: "Status",
    },
    {
      key: "created_at",
      title: "Added Date",
    },
    {
      key: 'action',
      title: 'Action'
    }
  ];


  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <div className="row mb-3 justify-content-between">
                  <div className="col-md-6 mb-2">
                    <h2 className="mainTitle">Favorites</h2>
                    <p className="text-muted">Total: {paginationData.total} favorites</p>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="addUser">
                      <CustomInput type="text" placeholder="Search by Listing ID or Title..." value={inputValue} inputClass="mainInput" onChange={handleChange} />
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-12">
                    {UseeListingLoading ? (
                      <div className="text-center py-4">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading favorites...</p>
                      </div>
                    ) : filterData?.length === 0 ? (
                      <div className="text-center py-4">
                        <p className="text-muted">No favorites found</p>
                        <Link to="/home" className="btn btn-primary">
                          Browse Listings
                        </Link>
                      </div>
                    ) : (
                      <>
                        <CustomTable headers={upcomingHeader}>
                          <tbody>
                            {filterData?.map((item, index) => {
                              // Debug: Log each item to see the structure
                              console.log('Favorite Item:', item);
                              
                              return (
                          <tr key={index}>
                                <td>{((paginationData.currentPage - 1) * paginationData.perPage) + index + 1}</td>
                                
                                <td>
                                  <Link to={`/listing-detial/${item?.list_id}`} className="text-dark">
                                    {item?.listing?.title || `Listing #${item?.list_id}`}
                                  </Link>
                                  <br />
                                  <small className="text-muted">ID: {item?.list_id}</small>
                                </td>
                                <td>
                                  <span className="badge bg-secondary">
                                    {item?.listing?.type_of_listing === 1 ? 'House' : 
                                     item?.listing?.type_of_listing === 2 ? 'Apartment' : 
                                     item?.listing?.type_of_listing ? `Type ${item?.listing?.type_of_listing}` : 'Unknown'}
                                  </span>
                                </td>
                                <td>
                                  <span className="badge bg-info">
                                    {item?.listing?.bathrooms || 0} Bathroom{(item?.listing?.bathrooms || 0) > 1 ? 's' : ''}
                                  </span>
                                </td>
                                <td>
                                  {item?.listing?.size ? `${item?.listing?.size} sq ft` : 'N/A'}
                                </td>
                                <td>
                                  <span className={`badge ${item?.listing?.status === 1 ? 'bg-success' : 'bg-danger'}`}>
                                    {item?.listing?.status === 1 ? 'Active' : 'Inactive'}
                                  </span>
                                </td>
                                <td>
                                  {item?.created_at ? (
                                    <FormatDateTime isoDateString={item?.created_at} />
                                  ) : (
                                    <span className="text-muted">No date</span>
                                  )}
                            </td>
                                <td>
                                  <Dropdown className="tableDropdown">
                                    <Dropdown.Toggle variant="transparent" className="notButton classicToggle">
                                      <FontAwesomeIcon icon={faEllipsisV} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu align="end" className="tableDropdownMenu" popperConfig={{ strategy: 'fixed' }}>
                                      <Link to={`/listing-detial/${item?.list_id}`} className="tableAction">
                                        <FontAwesomeIcon icon={faEye} className="tableActionIcon" />
                                        View Listing
                                      </Link>
                                      <button 
                                        className="tableAction text-danger" 
                                        onClick={() => handleRemoveFavorite(item?.list_id)}
                                        disabled={isRemoving}
                                      >
                                        <FontAwesomeIcon icon={faTrash} className="tableActionIcon" />
                                        {isRemoving ? 'Removing...' : 'Remove from Favorites'}
                                      </button>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                          </tr>
                              );
                            })}
                      </tbody>
                    </CustomTable>
                      </>
                    )}
                    <CustomPagination
                      itemsPerPage={paginationData.perPage}
                      totalItems={paginationData.total}
                      currentPage={paginationData.currentPage}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <CustomModal show={showModal} close={() => { setShowModal(false) }} action={inActive} heading='Are you sure you want to mark this user as inactive?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Inactive' />

          <CustomModal show={showModal3} close={() => { setShowModal3(false) }} action={ActiveMale} heading='Are you sure you want to mark this user as Active?' />
          <CustomModal show={showModal4} close={() => { setShowModal4(false) }} success heading='Marked as Active' />



        </div>
      </DashboardLayout>
    </>
  );
};



